import { Navigate, Route, Routes } from "react-router-dom";
import { SiteLayout } from "./components/layout";
import About from "./pages/About";
import { CasesOverview, SchenkCase } from "./pages/Cases";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import { ServiceDetail, ServicesOverview } from "./pages/Services";

export default function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<Home />} />
        <Route path="diensten" element={<ServicesOverview />} />
        <Route path="diensten/:slug" element={<ServiceDetail />} />
        <Route path="cases" element={<CasesOverview />} />
        <Route path="cases/schenk-recycling" element={<SchenkCase />} />
        <Route path="over-staql" element={<About />} />
        <Route path="ventures" element={<Navigate to="/over-staql" replace />} />
        <Route path="contact" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
